// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"b14c9130","453":"8ca8cbf8"}[chunkId] + ".chunk.js";
};